import { LOADING, LOGIN_SUCCESS, LOGOUT, SET_ACCESS_TOKEN, SET_CURRENT_USER_STATUS, SET_CURRENT_WEBSITE, SET_MESSAGE, SET_WEBSITE_LIST } from "../../Actions/Types";
import { SocialLoginActionApi } from "../../Api/UserAction/LoginActionApi";
import { DomainDetailsService } from "../DomainService/DomainDetails";
import { getPlanListService } from "../PlanListService";


// service to perform social login
const SocialLoginService = (
    username: string, // username
    email: string, // email address 
    sub: string, //auth ID
    dispatch: Function, // function to store redux data
    navigate: Function, // navigate function
    t: Function, // i18next t function
) => {

    console.log("SocialLoginService is called", email);

    // Loading
    dispatch({
        type: LOADING,
        payload: true,
    });


    // API to perform auto login
    SocialLoginActionApi(username, email, sub).then((autoLoginRes) => {


        console.log("autoLoginRes", autoLoginRes, autoLoginRes.Data, autoLoginRes.token);

        // checks if Auto Login Response data exist and access token received
        if (autoLoginRes.Data && autoLoginRes.token) {

            // service to get Current User Plans
            getPlanListService(autoLoginRes.token, 2, dispatch);

            let currentUserType: number;
            
            
            
            if(autoLoginRes.Data.department === 4) {
                // check if partner user has multi domain plan
                if (autoLoginRes.Data.is_multiple_domain === 1) {
                    currentUserType = 3
                } else {
                    currentUserType = 2
                }
            }
            // check if normal user has multi domain plan
            else if (autoLoginRes.Data.is_multiple_domain === 2) {
                currentUserType = 4
            }
            else {
                currentUserType = 1
            }

            //alert("currentUserType: " + currentUserType);
            // Set User type
            dispatch({
                type: SET_CURRENT_USER_STATUS,
                payload: {
                    currentUserType: currentUserType,
                    isInitUser: autoLoginRes.Data.website_lists.length === 0 ? true : false
                },
            });

            // Save access token
            dispatch({
                type: SET_ACCESS_TOKEN,
                payload: autoLoginRes.token,
            });

            // Save User Data
            dispatch({
                type: LOGIN_SUCCESS,
                payload: { user: autoLoginRes.Data },
            });

            // Set Website List
            dispatch({
                type: SET_WEBSITE_LIST,
                payload: autoLoginRes.Data.website_lists
            });

            // Set Current website ID
            let currentWebsiteID: number;

            // check if website list is available
            if (autoLoginRes.Data.website_lists.length > 0) {
                // check if website name exists
                currentWebsiteID = autoLoginRes.Data.website_lists[0].id;
                // service to get domain details
                DomainDetailsService(autoLoginRes.token, currentWebsiteID, dispatch).then((res) => {
                    //console.log("from auto login service");
                    // check if response is ok
                    if (res.status === 200) {

                        // Navigation
                        navigate("/front");


                        // remove Loading
                        dispatch({
                            type: LOADING,
                            payload: false,
                        });

                        // dispatch login successful message
                        dispatch({
                            type: SET_MESSAGE,
                            payload: {
                                "toast_message": t('Login Success Msg'),
                                "toast_type": "success",
                                "onclose": null
                            }
                        })

                    } else {

                        // remove Loading
                        dispatch({
                            type: LOADING,
                            payload: false,
                        });

                    }

                });
            }
            else {

                // navigate to getting started screen if no domain found
                navigate(`/front/getting-started`);

                // Set Website List
                dispatch({
                    type: SET_WEBSITE_LIST,
                    payload: null
                });

                // Set Current Website Data
                dispatch({
                    type: SET_CURRENT_WEBSITE,
                    payload: null
                });

                // Set Loading
                dispatch({
                    type: LOADING,
                    payload: false,
                });
            }


        } else {

            // perform Logout if no user data is found
            dispatch({
                type: LOGOUT,
            });

            navigate("/front/login?logout");

            // Loading
            dispatch({
                type: LOADING,
                payload: false,
            });

            // Res Msg
            dispatch({
                type: SET_MESSAGE,
                payload: {
                    "toast_message": t('Login Fail Msg'),
                    "toast_type": "danger",
                    "onclose": null
                }
            });

        }

    })

}

export { SocialLoginService }
